import actionTypes from '../constants/action-types';

const setTemplateSwitched = (isTemplateSwitched) => ({
  type: actionTypes.SET_TEMPLATE_SWITCHED,
  payload: { isTemplateSwitched },
});

export default setTemplateSwitched;
